import { calculateDiscounts, formatNumber } from "Utilities";
import _ from "lodash";
import {
    SET_BUDGET_BONIFICATION_MAX_LIMIT,
    SET_BUDGET_BONIFICATION_VALIDATOR,
    SET_BUDGET_AVAILABLE_BONIFICATION,
} from "./constants";
import { SALE_TYPE } from "common/Constants";

export function bonificationLimit() {
    return (dispatch, getState) => {
            
            const { presupuestador } = getState();
    
            const bonifMax = presupuestador?.nuevo?.precio_local
    
            const usedCarDiscount = presupuestador?.entregaUsados.map( car => {
                if (!car?.take_improvement_amount) return 0
                const bonifExtraPercentaje = presupuestador?.nuevo?.bonification?.taking_car_percentage
                const takingPrice = ( car.updatedTakePrice || car.original_price || car.auxOriginalPrice || car.appraisal )
            
                const discountNominalValue = Math.floor((Math.floor(takingPrice * bonifExtraPercentaje) / 100) / 1000) * 1000
                const price = car.take_improvement_amount - discountNominalValue
            
                return price <= 0 || !price ? 0 : price
              }).reduce((total, amount) => total + amount, 0) || 0
    
            dispatch({
                type: SET_BUDGET_BONIFICATION_MAX_LIMIT,
                data: bonifMax - usedCarDiscount - (presupuestador?.special_discount || 0) // bonificationLimit - menos las bonificaciones que ya se usaron)
            });
        }
}

export function setAvailableBonification() {
    return (dispatch, getState) => {

        const { presupuestador } = getState();

        const saleType = presupuestador?.tipoVentaSelected === 'venta_convencional' 
            ? presupuestador?.nuevo?.nuevo
                ? SALE_TYPE.CONVENTIONAL
                : SALE_TYPE.USED
            : SALE_TYPE.DIRECT

        const maxDiscount = calculateDiscounts({
            catalog: presupuestador?.nuevo,
            profileDiscounts: presupuestador.profileDiscounts,
            carLotId: presupuestador?.nuevo?.car_lot_id,
            saleType: saleType,
            saleQuantity:presupuestador.sumarCantidad
        }).maxDiscount;

        if (presupuestador?.nuevo?.precio_local) {

            const bonifMax = presupuestador?.nuevo?.precio_local

            const usedCarDiscount = presupuestador?.entregaUsados.map( car => {
                if (car.take_improvement_amount <= 0) return 0
                const price = car.take_improvement_amount
                return price <= 0 ? 0 : price
            }).reduce((total, amount) => total + amount, 0)

            dispatch({
                type: SET_BUDGET_AVAILABLE_BONIFICATION,
                data: bonifMax - usedCarDiscount - (presupuestador?.special_discount || 0), // bonificationLimit - menos las bonificaciones que ya se usaron)
                maxDiscount,
                saleType,
            });
        } else {
            dispatch({
                type: SET_BUDGET_AVAILABLE_BONIFICATION,
                data: 0
            });
        }
    }
}

export function bonificationValidator({
    producto,
    remainder,
    bonificacionVendedor,
    entregaUsados,
    inputValue
}) {
    return (dispatch, getState) => {

        const { presupuestador } = getState();

        const maxDiscount = presupuestador?.maxDiscount || 0

        const usedCarDiscount = entregaUsados.map( car => {
            if (car.take_improvement_amount <= 0) return 0
            const price = _.round((car.take_improvement_amount - ( car.updatedTakePrice || car.original_price || car.auxOriginalPrice || car.appraisal ) * producto?.bonification?.taking_car_percentage / 100) / 1000) * 1000
            return price <= 0 ? 0 : price
        }).reduce((total, amount) => total + amount, 0)
        

        const bonificationMaxLimit = presupuestador.bonificationLimit

        const R = bonificacionVendedor > remainder ? maxDiscount - usedCarDiscount : remainder + bonificacionVendedor

        const showDiscountAlertNewCard = inputValue > R

        const isValid = inputValue >= 100 && inputValue <= presupuestador?.bonificationAvailable // bonificationMaxLimit

        const tooltipText = `No puede ser mayor a ${producto.currency_symbol}${formatNumber.separator(bonificationMaxLimit)}`

        dispatch ({
            type: SET_BUDGET_BONIFICATION_VALIDATOR,
            data: {
                maxDiscount,
                bonificationLimit: bonificationMaxLimit,
                showDiscountAlertNewCard,
                errorInputValidation: !isValid,
                tooltipTextCarNew: presupuestador?.sale_type === 'DIRECTA' ? tooltipText : '',
            }
        });
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case SET_BUDGET_BONIFICATION_MAX_LIMIT:
        return {
            ...state,
            bonificationLimit: action.data
        };
        case SET_BUDGET_BONIFICATION_VALIDATOR:
        return {
            ...state,
            bonificationData: action.data
        };
        case SET_BUDGET_AVAILABLE_BONIFICATION:
        return {
            ...state,
            bonificationAvailable: action.data,
            maxDiscount: action.maxDiscount,
            sale_type: action.saleType,
        };
        default:
        return state;
    }
}
